<template>
  <div>
    <span class="name">{{ post.title }}</span>
    <div v-if="post.content">
      <div
        v-if="showFullContent || !contentTooLarge"
        class="content"
        v-html="content"
        v-linkify
      />
      <div
        v-if="contentTooLarge && !showFullContent"
        class="content"
        v-html="truncatedContent"
        v-linkify
      />
      <a
        href="#"
        v-if="contentTooLarge && !showFullContent"
        @click.stop.prevent="seeMore()"
        class="more"
      >
        <span>{{ $t('search.postSearch.more') }}</span>
        <img src="@/assets/Arrow-Down.svg" />
      </a>
    </div>
  </div>
</template>

<script>
import linkify from 'vue-linkify'

export default {
  name: 'PostSearch',
  data () {
    return {
      showFullContent: false
    }
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  directives: {
    linkify
  },
  methods: {
    seeMore () {
      this.showFullContent = true
    }
  },
  computed: {
    content () {
      return this.post.content
    },
    contentTooLarge () {
      return this.post.content && this.post.content.length > 200
    },
    truncatedContent () {
      return this.post.content.substring(0, 200).concat('...')
    }
  }
}
</script>

<style scoped lang="scss">

.more {
    display: flex;
    justify-content: flex-end;
    color: $primary-color;
    font-weight: 600;
    margin-right: 1rem;
    font-size: 16px;
    text-decoration: none;

    img {
        margin-top: 1px;
    }
}

.name {
    font-weight: 700;
    color: $primary-color;
    font-size: 16px;
    cursor: pointer;
}

.content {
    overflow-wrap: break-word;
}

</style>
